import { useEffect, useState } from 'react';

import { callStatusLabels, fmtDuration } from './format';

// CallStatusBar: Stand des laufenden Anrufs (Akquise, Anruf zur Terminbestätigung) – Status, Dauer, Stumm, Auflegen.
export function CallStatusBar({
  status,
  startedAt,
  endedAt,
  failure,
  onEnd,
  muted,
  onMute,
  browser,
  inbound,
}: {
  status: string;
  startedAt?: string | null;
  endedAt?: string | null;
  failure?: string | null;
  onEnd?: () => void;
  muted?: boolean;
  onMute?: () => void;
  browser?: boolean;
  inbound?: boolean;
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (endedAt) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [endedAt]);
  const seconds = startedAt ? ((endedAt ? new Date(endedAt).getTime() : now) - new Date(startedAt).getTime()) / 1000 : 0;
  return (
    <div className={`call-status call-${status.toLowerCase()}`} role="status" aria-live="polite">
      <span className="call-dot" aria-hidden="true" />
      {inbound && <span className="badge badge-muted">Rückruf des Kunden</span>}
      <strong>
        {inbound && status === 'RINGING'
          ? 'Wird verbunden'
          : browser && status === 'INITIATED'
            ? 'Verbindung wird aufgebaut'
            : (callStatusLabels[status as keyof typeof callStatusLabels] ?? status)}
      </strong>
      {startedAt && <span className="call-timer">{fmtDuration(seconds)}</span>}
      {failure && <span className="muted">({failure})</span>}
      {muted !== undefined && onMute && (
        <button type="button" className="btn btn-small" aria-pressed={muted} onClick={onMute}>
          {muted ? 'Mikrofon an' : 'Stumm'}
        </button>
      )}
      {onEnd && (
        <button type="button" className="btn btn-danger btn-small" onClick={onEnd}>
          Auflegen
        </button>
      )}
    </div>
  );
}
